// React
import { FunctionComponent } from "react";
// Components
import JunoPage from "../../components/JunoPage/JunoPage";
// Fhir front library
import { InProgressPage, Title } from "@fyrstain/hl7-front-library";
// Translation
import i18n from "i18next";
import { toPublicUrl } from "../../services/PublicUrl";

const InProgress: FunctionComponent = () => {
  //////////////////////////////
  //          Content         //
  //////////////////////////////

  return (
    <JunoPage loading={false} fitFooter={true} needsLogin={false}>
      <InProgressPage
        heading={
          <Title
            level={1}
            prefix={i18n.t("status.inProgress.prefix")}
            content={i18n.t("status.inProgress.content")}
          />
        }
        illustration={<img src={toPublicUrl("/assets/InProgress.png")} alt="" />}
      />
    </JunoPage>
  );
};

export default InProgress;
